import React, { useState, useEffect } from 'react';
import { Button, Icon } from '@polichat/flamboyant';
import { toast } from 'react-toastify';
import { launchWhatsAppCoexistence } from './launchWhatsAppCoexistence';
import { sendCoexistenceToken } from './sendCoexistenceToken';
import {
  ButtonOpenFB,
  LoadingContainer
} from './EmbeddedSignupFlow.styles';

interface CoexistenceData {
  waba_id: string;
  business_id?: string;
  phone_number_id?: string;
  phone_number?: string;
  display_name?: string;
  access_token?: string;
}

interface Props {
  onCallbackSDK: (value: any[]) => void;
  setErrorSdkFb: (hasError: boolean) => void;
  customer?: number;
}

const EmbeddedSignupFlow = ({
  setErrorSdkFb,
  onCallbackSDK,
  customer,
}: Props) => {
  console.log('📦 EmbeddedSignupFlow component mounted');
  console.log('Props - customer:', customer);
  
  const [debugToken, setDebugToken] = useState<string>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (debugToken === 'ERROR') {
      setErrorSdkFb(true);
    } else {
      setErrorSdkFb(false);
    }

    if (debugToken && debugToken !== 'ERROR') {
      sendTokenToBackend(debugToken);
    }
  }, [debugToken]);

  const sendTokenToBackend = async (debugToken: string) => {
    setIsLoading(true);
    try {
      const data = await sendCoexistenceToken(debugToken, customer);
      
      if (!data) {
        setErrorSdkFb(true);
        setIsLoading(false);
        return;
      }

      if (Array.isArray(data)) {
        toast.success('Conectado com sucesso ao WhatsApp Business!');
        onCallbackSDK(data);
      }
    } catch (error) {
      console.error('Erro ao enviar token:', error);
      setErrorSdkFb(true);
      setIsLoading(false);
      
      // Don't show additional toast here as sendCoexistenceToken already handles it
    } finally {
      setIsLoading(false);
    }
  };

  const handleFacebookLogin = () => {
    console.log('🎯 handleFacebookLogin CALLED');
    console.log('Customer:', customer);
    
    setIsLoading(true);
    setErrorSdkFb(false); // Reset error state
    
    try {
      console.log('⏳ About to call launchWhatsAppCoexistence...');
      // For coexistence flow, we rely on the Facebook event callback, not the token processing
      // The event FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING returns all needed data
      launchWhatsAppCoexistence(
        // Don't set debugToken to avoid triggering sendTokenToBackend
        (token: string) => {
          console.log('Access token received (not used in coexistence):', token);
          // Token is stored but won't trigger the useEffect
        }, 
        customer, 
        (data: CoexistenceData) => {
          console.log('Coexistence onboarding data received:', data);
          setIsLoading(false);
          
          // Handle the coexistence onboarding completion
          // The data from the event already contains waba_id, phone_number_id, etc
          if (data && data.waba_id) {
            toast.success('WhatsApp Business conectado! Complete o cadastro do canal.');
            
            // Format data to match expected structure
            const formattedData = [{
              waba_id: data.waba_id,
              business_id: data.business_id || data.waba_id,
              phone_number_id: data.phone_number_id || null,
              phone_number: data.phone_number || null,
              display_name: data.display_name || 'WhatsApp Business',
              access_token: data.access_token || null,
              coexistenceEnabled: true,
              shareChats: true,
              connectionType: 'coexistence'
            }];
            
            onCallbackSDK(formattedData);
          } else {
            toast.error('Dados de integração incompletos. Tente novamente.');
            setErrorSdkFb(true);
          }
        }
      );
      console.log('✅ launchWhatsAppCoexistence call completed');
    } catch (error) {
      console.error('❌ Erro ao iniciar login do Facebook:', error);
      if (error instanceof Error) {
        console.error('Error stack:', error.stack);
      }
      toast.error('Erro ao abrir janela de login do Facebook. Verifique se popups estão permitidos.');
      setErrorSdkFb(true);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <LoadingContainer>
        <Icon icon="poli-icon pi-loading-fill" size={20} />
        <span>Conectando com Facebook...</span>
      </LoadingContainer>
    );
  }

  return (
    <div>
      <ButtonOpenFB>
        <Button
          size="sm"
          color="info"
          onClick={() => {
            console.log('🔴 BUTTON CLICKED!');
            handleFacebookLogin();
          }}
          disabled={isLoading}
        >
          <Icon icon={'poli-icon pi-facebook-fill'} color="white" size={20} />
          <span>Entrar com Facebook</span>
        </Button>
      </ButtonOpenFB>
    </div>
  );
};

export { EmbeddedSignupFlow };
